import React, { useState, useEffect } from 'react'
import Header from '../Core/Header'
import Cookies from "js-cookie";
import { getAllHospitals, createHospitalMapping } from '../../service/operations/api_methods' 
import { toast } from 'sonner';

const FindHospitals = () => {
    const [list, setList] = useState([])

     const fetchHospitals = async () => {
            try {
                const res = await getAllHospitals()
                const result = res.data 
                console.log("list of hospital",res.data);
                

                if (result.success && result.data) {
                    let mappedData = result.data.map((item) => ({
                        // ✅ ROBUST ID CHECK: Try all common ID names
                        id: item.id || item.hospital_user_id || item.user_id || item._id, 
                        
                        name: item.hospital_name,
                        Address: item.address,
                        Registered: item.license_number,
                        Patients: "150",
                        TestProvided: ["General Checkup", "Blood Test", "X-Ray"],
                        Doctors: ["Dr. Available", "Dr. On Call"],
                        user_id:item.user_id,
                        alreadyMapped:item.alreadyMapped,
                        requestStatus:item.requestStatus
                    }))
                   let finalList=mappedData.filter(i=>i.alreadyMapped===false)
                    setList(finalList)
                }
            } catch (error) {
                console.log("Error fetching hospitals:", error)
            }
        }

    useEffect(() => {
       
        fetchHospitals()
    }, [])

    const handleAssign = async (hospitalId) => {
        console.log(hospitalId);
        
        try {
            const token = localStorage.getItem("token") 
            const doctorUserId = JSON.parse(Cookies.get("user")).user_id

            // ✅ DEBUG: Check values before sending
            console.log("Attempting Assign -> Token:", !!token, "DocID:", doctorUserId, "HospID:", hospitalId);

            if(!token) {
                toast.info("Session Expired. Please Login Again.")
                return
            }
            if(!doctorUserId) {
                toast.info("Doctor ID missing. Please Re-Login.")
                return
            }
            if(!hospitalId) {
                toast.info("Hospital ID missing. Cannot assign.")
                return
            }

            const response = await createHospitalMapping({
                hospital_id: hospitalId,
                doctor_user_id: doctorUserId,
                token: token
            })
            console.log(response.data);
            

            if(response.data.success) {
                toast.success("Hospital assigned successfully!")
                fetchHospitals()
            } else {
                toast.error(response.data.message || "Failed to assign hospital.")
            }
        } catch (error) {
            console.log("Error assigning hospital:", error)
            
            // ✅ HANDLE CONFLICT (409) - Already Mapped
            if (error.status === 409 || error.response?.status === 409) {
                toast.info("This hospital is ALREADY assigned to you.");
            } 
            // Handle Bad Request (400)
            else if (error.status === 400 || error.response?.status === 400) {
                 toast.info("Bad Request: Please check console for missing IDs.");
            }
            else {
                toast.info("Something went wrong while assigning.");
            }
        }
    }

  return (
    <div style={{height:"100vh",width:"100%", overflow:"hidden"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-between",padding:"6px"}}>
            <p style={{color:"white"}}>All Hospitals</p>
            <input placeholder='Search hospital by Adhaar'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
        </div>
        
        <div style={{height:"calc(100vh - 180px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item, index)=>(
                <div key={item.id || index} style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p onClick={() => handleAssign(item.user_id)} 
                       style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        {
                            item.requestStatus==='PENDING'?"Requested":"Add to Assign"
                        }
                        </p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"160px",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{item.Patients}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.Registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            {
                            item.TestProvided.map((i, idx)=>
                            <p key={idx} style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            {
                            item.Doctors.map((i, idx)=>
                            <p key={idx} style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>
                </div>
            ))
            }
        </div>
      </section>
    </div>
  )
}

export default FindHospitals